<script lang="ts" setup>
import { GetMovementDocument } from '~/utils/generated/graphql'
import { useGraphQuery } from '~/utils/graphql/client'

const { locale } = useI18n()
const { data: movement } = await useGraphQuery(GetMovementDocument, { locale: locale })

defineProps<{
  toggleOpen: () => void
}>()
</script>

<template>
  <div>
    <div class="meta-info mb-2">
      {{ $t('aroundTheMovement') }}
    </div>
    <ul>
      <li
        v-for="location in movement?.collection?.items?.items || []"
        :key="location.slug"
        class="h3 text-gray-500 hover:text-black"
      >
        <PLink
          :id="'around-the-movement-' + location.slug"
          :to="'/collections/' + location.slug"
          :click="toggleOpen"
        >
          {{ location.title }}
        </PLink>
      </li>
    </ul>
  </div>
</template>
